// tslint:disable:max-line-length

import React from 'react';

export const ObjectVideo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,1.9v12h16v-12H0z M5.5,10.9v-6l5,3L5.5,10.9z" />
    </svg>
  );
};
